// extracted by mini-css-extract-plugin
export var Splash = "splash-module--Splash--346cg";
export var Splash_hidden = "splash-module--Splash_hidden--7K5uj";
export var Splash__loader = "splash-module--Splash__loader--jnyKI";